import { get } from 'lodash';

const root = state => get(state, 'ControlInformationState.districtInfo');

export const getData = state => get(root(state), 'data', null);
export const getFetchError = state => get(root(state), 'fetchError', null);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getFetching = state => get(root(state), 'fetching', false);

//mobile inventory license
export const getFetchingMobileInventoryLicense = state =>
  get(root(state), 'fetchingMobileInventoryLicense', false);
export const getMobileInventoryLicenseData = state =>
  get(root(state), 'mobileInventoryLicenseData', 0);
export const getFetchMobileInventoryLicenseError = state =>
  get(root(state), 'fetchMobileInventoryLicenseError', null);
export const getInvAppEnabled = state =>
  get(getData(state), 'INV_AppEnabled', false);

export const getFetchingMobileSync = state =>
  get(root(state), 'fetchingMobileSync', false);
export const getMobileSyncResponseMsg = state =>
  get(root(state), 'mobileSyncResponseMsg', '');
export const getFetchMobileSyncError = state =>
  get(root(state), 'fetchMobileSyncError', null);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/districtInfo/selectors.js